import { type VBaseInputProps } from '../VBaseInput';
import VInnerInput from './VInnerInput';
import VInputTextareaWrapper from './VInputTextareaWrapper';
import type { VInputProps, VInputType } from './type';

const VInput = <T extends VInputType>({
  ref,

  className,
  comment,
  disabled,
  fluid,
  id,
  label,
  orientation,
  required,
  style,
  size,
  valid,
  ...inputProps
}: VInputProps<T> &
  VBaseInputProps &
  Omit<React.ComponentPropsWithRef<'input'>, 'size' | 'type'>) => {
  const baseInputProps = {
    className,
    comment,
    disabled,
    fluid,
    id,
    label,
    orientation,
    required,
    size,
    style,
    valid,
    readOnly: inputProps.readOnly,
  };

  return (
    <VInputTextareaWrapper {...baseInputProps}>
      <VInnerInput ref={ref} {...inputProps} size={size} />
    </VInputTextareaWrapper>
  );
};

export default VInput;
